import {
  CheckCircleOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { Col, Divider, Row } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Spin from "../../components/general/antd/spin";
import PageHeader from "../../components/general/layout/page-header";
import Card from "../../components/home/cards";
import EndPoints from "../../services/end-points";
import Chart from "../../components/general/charts/pie";
import StoreProductStats from "../../components/home/store-product-stats";
import { IStore } from "../../models/store/response";
import { IStatistics } from "../../models/statistcs/respons";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import AreaClientStats from "../../components/home/area-client-stats";
import AreaDeliveryTimeStats from "../../components/home/area-delivery-time-stats";
interface IProps { }

const Home: React.FC<IProps> = (props) => {
  const [stors, setStors] = useState<IStore[]>([]);
  const { t } = useTranslation();

  const [coordinates, setCoordinates] = useState<IStore[]>([]);

  const [statistics, setStatistics] = useState<IStatistics>();
  const [statisticsLoading, setStatisticsLoading] = useState(true);
  const areaClientStats = statistics?.AreaClientStats;
  const allClientCount =
    areaClientStats?.totalClientCount ?? statistics?.ClientCount ?? 0;
  const realClientCount = areaClientStats?.realTotalClientCount ?? 0;

  const getAllStatistics = async () => {
    try {
      setStatisticsLoading(true);
      const a = await EndPoints.statistics.getAllStatistics({});
      setStatistics(a?.data);
    } catch (error) {
    } finally {
      setStatisticsLoading(false);
    }
  };

  useEffect(() => {
    getAllStatistics();
  }, []);

  // store
  useEffect(() => {
    const getStores = async () => {
      try {
        const { data } = await EndPoints.store.getAllStores({
          perPage: -1,
        });
        setStors(data.data);

        setCoordinates(data?.data.map((data) => data));
      } catch (error) {
      }
    };

    getStores();
  }, []);

  return (
    <>
      <PageHeader
        title={t("home_title")}
        extra={[
          <RefreshBtn
            key={0}
            loading={statisticsLoading}
            onClick={() => getAllStatistics()}
          >
            {t("refresh")}
          </RefreshBtn>,
        ]}
      />
      {statisticsLoading ? (
        <Spin />
      ) : (
        <>
          <Row gutter={[8, 8]}>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("ClientCount")}
                title={t("ClientCount")}
                icon={<UsergroupAddOutlined />}
                count={allClientCount}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("real_client_count")}
                title={t("real_client_count")}
                icon={<CheckCircleOutlined />}
                count={realClientCount}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("DeliveryCount")}
                title={t("DeliveryCount")}
                icon={<UsergroupAddOutlined />}
                count={statistics?.DeliveryCount}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("DeliveryCountWork")}
                title={t("DeliveryCountWork")}
                icon={<UsergroupAddOutlined />}
                count={statistics?.DeliveryCountWork}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("OrderCount")}
                title={t("OrderCount")}
                icon={<UsergroupAddOutlined />}
                count={statistics?.OrderCount}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("OrderInProgressCount")}
                title={t("OrderInProgressCount")}
                icon={<UsergroupAddOutlined />}
                count={statistics?.OrderInProgressCount}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("StoreCount")}
                title={t("StoreCount")}
                icon={<UsergroupAddOutlined />}
                count={statistics?.StoreCount}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("StoreActiveCount")}
                title={t("StoreActiveCount")}
                icon={<UsergroupAddOutlined />}
                count={statistics?.StoreActiveCount}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("PharmacistsCount")}
                title={t("PharmacistsCount")}
                icon={<UsergroupAddOutlined />}
                count={statistics?.PharmacistsCount}
              />
            </Col>
            <Col xl={8} lg={12} xs={24}>
              <Card
                toolTip={t("PharmacistsActiveCount")}
                title={t("PharmacistsActiveCount")}
                icon={<UsergroupAddOutlined />}
                count={statistics?.PharmacistsActiveCount}
              />
            </Col>
          </Row>
          <Divider orientation="center">{t("statistics")}</Divider>
          <Row gutter={[28, 28]}>
            <Col xs={24} sm={12} md={8}>
              <Chart
                lables={[t("DeliveryCount"), t("DeliveryCountWork")]}
                count={[
                  statistics?.DeliveryCount,
                  statistics?.DeliveryCountWork,
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Chart
                lables={[t("OrderCount"), t("OrderInProgressCount")]}
                count={[
                  statistics?.OrderCount,
                  statistics?.OrderInProgressCount,
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Chart
                lables={[t("StoreCount"), t("StoreActiveCount")]}
                count={[statistics?.StoreCount, statistics?.StoreActiveCount]}
              />
            </Col>
          </Row>
          <AreaClientStats stats={areaClientStats} />
          <AreaDeliveryTimeStats
            stats={statistics?.AreaDeliveryTimeStats}
            onChange={(areaDeliveryTimeStats) =>
              setStatistics((current) =>
                current
                  ? {
                    ...current,
                    AreaDeliveryTimeStats: areaDeliveryTimeStats,
                  }
                  : current
              )
            }
          />
          <StoreProductStats stats={statistics?.StoreProductStats} />
        </>
      )}
    </>
  );
};

export default Home;
